<!-- sm-training-test -->
<template>
  <div class="training-test">
    <div class='training-test-main'>
      <p class='training-test-desc'>Congratulations, you passed the interview and signed the contract. To provide high-quality and consistent service for mentees, ZLR set a Mentor Guide open-book Test as a training (which can be found the link below), please refer to the material below to finish the test within 48 hours. You will successfully onboard and start the mentorship journey with ZLR after passing the Mentor Guide Test. Good Luck! </p>
      <a class='training-test-link'
         href="https://ks.wjx.top/jq/53720465.aspx">https://ks.wjx.top/jq/53720465.aspx</a>
      <div class='training-test-pdf-wrap'>
        <div class='training-test-pdf'>
          <iframe :src="currentUrl"
                  frameborder="0"
                  style='width: 100%;height: 800px;'></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'apply-em-training-test',
  computed: {},
  data () {
    return {
      // pdf链接
      currentUrl: 'https://res.zailairen.com/msp/docs/mentor/20200207/2019 Graduate EM Guide.pdf'
    }
  },
  mounted () {

  },
  methods: {
  }
}
</script>
<style lang='less' scoped>
</style>
